import { useEffect, useRef, useState } from "react";

export const CustomSelect = ({
  title,
  titleColor,
  children,
  options,
  selectedOption,
  onChange,
}: {
  title: string;
  titleColor: string;
  children?: React.ReactNode;
  options: { text: string; value: string }[];
  selectedOption: string;
  onChange: (value: string) => void;
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [showDropdown, setShowDropdown] = useState(false);

  // Close dropdown if clicked outside of it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false); // Close dropdown when clicking outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownRef]);

  return (
    <div
      className="custom-select"
      // onClick={() => setShowDropdown(!showDropdown)}
    >
      <p>{title}</p>
      <div
        className="custom-select__selected-option"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <span>{selectedOption}</span>
        <i className="bi bi-chevron-down"></i>
      </div>
      {showDropdown ? (
        <div className="dropdown-container" ref={dropdownRef}>
          <ul className="dropdown-container__options">
            {options.map((option) => (
              <li
                key={option.value}
                value={option.value}
                className={`${
                  option.value.toLowerCase() === selectedOption.toLowerCase()
                    ? "active"
                    : ""
                }`}
                onClick={() => {
                  setShowDropdown(false);
                  onChange(option.value);
                }}
              >
                {option.text}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};
